import { GeoCodeRenderer } from '@dataGrid/components/cellRenderer/index';
import { ArrowRight, ArrowDropDown } from '@material-ui/icons';
import RecommendationRenderer from '../Grid/cellRenderer/RecommendationRenderer';
import { DRIVER_RECOMMENDATION_COL_ID } from '../Grid/headerRenderer/constants';
import { StyledGroupCellRenderer } from './styles';
import PickupNumberRenderer from '../Grid/cellRenderer/PickupNumberCellRenderer';
import ClosingSoonTimeRenderer from '../Grid/cellRenderer/ClosingSoonTimeRenderer';
import { isSingleInGroupPickups, isGroupHeaders } from './utils';

const preventEventPropagation = (e) => {
  e.preventDefault();
  e.stopPropagation();
  if (e.stopImmediatePropagation) {
    e.stopImmediatePropagation();
  }
};

const getPickupTypeString = (allPickupTypes, pickupType) => {
  if (allPickupTypes?.length) {
    return allPickupTypes.join(', ');
  }
  return pickupType?.length ? pickupType.join(', ') : '';
};

const GroupCellRenderer = (props) => {
  const { classes, data, colDef, context, value } = props;
  const colId = colDef?.colId;
  const field = colDef?.field || colId;
  const dataId = data?.id;

  if (!isGroupHeaders(data)) {
    if (colId === DRIVER_RECOMMENDATION_COL_ID && isSingleInGroupPickups(data)) {
      return <RecommendationRenderer {...props} />;
    }
    if (colId === 'isGeoCoded' && isSingleInGroupPickups(data)) {
      return <GeoCodeRenderer {...props} value={data.isGeoCoded} />;
    }
    return value || '';
  }

  if (!context) {
    return value || '';
  }

  const isExpanded = context.expanded?.has?.(dataId) || false;

  const toggle = (e) => {
    preventEventPropagation(e);
    if (typeof context.toggle === 'function') {
      context.toggle(dataId);
    }
  };

  switch (field) {
    case 'isMergedPickup':
      return (
        <div
          onClick={toggle}
          onMouseDown={preventEventPropagation}
          onPointerDown={preventEventPropagation}
          className={classes.expandButton}>
          {isExpanded ? <ArrowDropDown /> : <ArrowRight />}
        </div>
      );

    case 'shipperName':
      return (
        <div className={classes.shipperNameContainer}>
          <span className={classes.groupCount}>({data.groupCount})</span>
          {data.shipperName}
        </div>
      );

    case 'pickupNumberList':
      return (
        <PickupNumberRenderer
          {...props}
          data={{
            ...data,
            ...data.groupAggregatedData
          }}
          isGroupHeader={true}
          value={data.pickupNumber}
        />
      );

    case 'closingSoon':
      return (
        <ClosingSoonTimeRenderer
          value={props.context.getGroupClosingSoonPickupTime?.(props.data.pickupNumberIdList)}
        />
      );

    case 'isGeoCoded':
      return <GeoCodeRenderer {...props} value={data.isGeoCoded} />;

    case 'pickupType':
      return getPickupTypeString(data.allPickupTypes, data.pickupType);

    case 'specialInstructions':
      return data.allSpecialInstructions || data.specialInstructions || '';

    case 'quoteNumber':
      return data.allQuoteNumbers || data.quoteNumber || '';

    case DRIVER_RECOMMENDATION_COL_ID:
      return <RecommendationRenderer {...props} />;

    default:
      return value || '';
  }
};

export default StyledGroupCellRenderer(GroupCellRenderer);
